import { supabase } from './supabaseClient';

// Cache the invited emails list so we only fetch once per session
let _cachedEmails = null;

export async function fetchInvitedEmails() {
  if (_cachedEmails) return _cachedEmails;
  const { data, error } = await supabase
    .from('invited_emails')
    .select('email');
  if (error) {
    console.error('Failed to fetch invited emails:', error.message);
    return [];
  }
  _cachedEmails = data.map(row => row.email.toLowerCase());
  return _cachedEmails;
}

// Check if a given email is in the invited list
export async function isInvited(email) {
  const emails = await fetchInvitedEmails();
  return emails.includes(email?.toLowerCase());
}

// Clear the in-memory cache (call after adding/removing invited emails)
export function clearInvitedEmailsCache() {
  _cachedEmails = null;
}
